import { Link } from "react-router-dom";
import clsx from "clsx";

const ACTION_CLASSES =
  "inline-flex items-center justify-center gap-2 rounded-control font-medium transition-colors " +
  "text-sm px-4 py-2 bg-brand text-white hover:bg-brand-hover dark:bg-brand-fillOnDark dark:hover:bg-brand-dark";

// Shared list-page header: title + optional single primary action, wrapping
// with a guaranteed gap on narrow viewports instead of sitting flush.
// actionTo renders a router Link (for navigation); actionOnClick renders a
// button (for in-place actions, e.g. Inventory's tab-gated "+ New item").
export default function PageHeader({ title, actionLabel, actionTo, actionOnClick, className }) {
  const hasAction = Boolean(actionLabel && (actionTo || actionOnClick));
  return (
    <div className={clsx("flex flex-wrap items-center justify-between mb-6 gap-4", className)}>
      <h1 className="text-2xl font-semibold text-sky-800 dark:text-sky-300">{title}</h1>
      {hasAction && (
        actionTo ? (
          <Link to={actionTo} className={ACTION_CLASSES}>
            {actionLabel}
          </Link>
        ) : (
          <button onClick={actionOnClick} className={ACTION_CLASSES}>
            {actionLabel}
          </button>
        )
      )}
    </div>
  );
}
